<!-- 组件说明 -->
<template>
  <div class="goods_list" :style="goodsListStyle">
    <el-row type="flex" style="flex-wrap:wrap">
      <el-col :span="data.prop.listStyle|intFormat" v-for="(item,index) in data.data" :key="index">
        <div class="item_padding">
          <div :class="['goods_item']" @click="goDetail(item.prodId)">
            <img :src="item.pic" class="goods_img" />
            <div class="content">
              <div class="goods_name">{{item.prodName}}</div>
              <div class="goods_menu">
                <div class="price">
                  <span v-if="data.prop.priceShow != '1'" :style="priceStyle">{{$t('Pay.money')}}{{item.price}}</span>
                </div>
                <!-- <div
                  v-if="data.prop.btnType == '2'||data.prop.btnType == '3'"
                  class="buy_btn"
                  :style="btnStyle"
                >购买</div>
                <div
                  v-if="data.prop.btnType == '4'||data.prop.btnType == '5'"
                  class="btn_wrapper_circle"
                  :style="btnStyle"
                >
                  <i class="el-icon-plus"></i>
                </div>-->
                <!-- <div
                  v-if="data.prop.btnType == '6'||data.prop.btnType == '7'"
                  class="btn_wrapper_cart"
                  :style="btnStyle"
                >
                  <i class="el-icon-delete"></i>
                </div>-->
              </div>
            </div>
            <div
              v-if="data.prop.iconType !== '1'"
              :class="[`tricon${data.prop.iconType}`]"
              :style="iconStyle"
            >{{data.prop.iconAttr}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { nextTick } from 'q';
import { moneys } from "../../../../static/moneyString"
//import x from ''
export default {
  components: {},
  props: ['data'],
  data() {
    return {moneysString:''};
  },
  filters: {
    intFormat: function(value) {
      return parseInt(value);
    },
  },
  computed: {
    goodsListStyle() {
      return `backgroundColor:${
        this.data.prop.backgroundColor == null ? '#00000000' : this.data.prop.backgroundColor
      }`;
    },
    priceStyle() {
      return `color:${this.data.prop.priceColor == null ? '#00000000' : this.data.prop.priceColor}`;
    },
    nameStyle() {
      return `color:${this.data.prop.nameColor == null ? '#00000000' : this.data.prop.nameColor}`;
    },
    btnStyle() {
      switch (this.data.prop.btnType) {
        case '2':
        case '4':
        case '6':
          return `color:${
            this.data.prop.btnColor == null ? '#00000000' : this.data.prop.btnColor
          };border: 0.04rem solid ${
            this.data.prop.btnColor == null ? '#00000000' : this.data.prop.btnColor
          };`;
        case '3':
        case '5':
        case '7':
          return `color:#fff;backgroundColor: ${
            this.data.prop.btnColor == null ? '#00000000' : this.data.prop.btnColor
          };`;
      }
    },
    iconStyle() {
      return `backgroundColor:${
        this.data.prop.iconColor == null ? '#00000000' : this.data.prop.iconColor
      }`;
    },
  },
  methods: {
    goDetail(id) {
      this.$router.push({ name: 'GoodsCategoryDetail', params: { prodId: id,type:' '} });//首页的列表指定到套餐的详情页面
    },
  },
  created() {
    //生命周期 - 创建完成
    // console.log('=======this.data=====',this.data);
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
  },

  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.goods_list {
  display: flex;
  justify-content: space-between;
  padding: 0.1rem 0.1rem;
  flex-wrap: wrap;
  .item_padding {
    padding: 0.1rem;
  }
  .goods_item {
    align-items: flex-start;
    position: relative;
    overflow: hidden;
    border-radius: 0.12rem;
    border: 0.04rem #ededed solid;
    .goods_img {
      width: 100%;
      display: block;
      background: pink;
    }
    .content {
      padding: 0.32rem;
      .goods_name {
        margin-bottom: 0.32rem;
      }
      .goods_menu {
        display: flex;
        align-items: center;
        .price {
          flex: 1;
        }
        .buy_btn {
          background: #fff;
          padding: 0.15rem 0.25rem;
          border: 0.04rem #ddd solid;
          border-radius: 0.12rem;
        }
        .btn_wrapper_circle {
          padding: 0.2rem;
          border-radius: 0.64rem;
          border: 0.04rem solid #dede;
        }
        .btn_wrapper_cart {
          padding: 0.2rem;
          border-radius: 0.16rem;
        }
      }
    }
    .tricon2 {
      width: 4.8rem;
      height: 0.8rem;
      line-height: 0.8rem;
      color: #fff;
      position: absolute;
      top: 0.4rem;
      left: -1.44rem;
      background: red;
      /*角*/
      -webkit-box-transform: rotate(-45deg);
      -moz-box-transform: rotate(-45deg);
      transform: rotate(-45deg);
      /**/
      -webkit-box-shadow: 0px 0px 0.4rem #888;
      -moz-box-shadow: 0px 0px 0.4rem #888;
      box-shadow: 0px 0px 0.4rem #888;
      /**/
      text-align: center;
    }
    .tricon3 {
      width: 4.8rem;
      height: 2rem;
      line-height: 2.8rem;
      color: #fff;
      position: absolute;
      top: -0.32rem;
      left: -1.76rem;
      /*角*/
      -webkit-box-transform: rotate(-45deg);
      -moz-box-transform: rotate(-45deg);
      transform: rotate(-45deg);
      /**/
      -webkit-box-shadow: 0px 0px 0.4rem #888;
      -moz-box-shadow: 0px 0px 0.4rem #888;
      box-shadow: 0px 0px 0.4rem #888;
      /**/
      text-align: center;
    }
    .tricon4 {
      width: 3.04rem;
      height: 1.01rem;
      line-height: 1.01rem;
      color: #fff;
      position: absolute;
      top: 0;
      left: 0;
      background: red;
      text-align: center;
    }
    .tricon5 {
      width: 2rem;
      height: 2rem;
      line-height: 2rem;
      border-radius: 0.12rem;
      background-color: red;
      color: #fff;
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
    }
    .tricon6 {
      width: 2rem;
      height: 2rem;
      line-height: 2rem;
      border-radius: 2rem;
      color: #fff;
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/GoodsList.vue